

<ng-container *ngIf="isEmbed">
  <ion-input type="text" (click)="buttonClickCB()" (focus)="buttonClickCB()" [readonly]="true" [value]="buttonLabel" [style]="'display: none;'"></ion-input>

  <table class="embed">
    <tr>
      <td style="padding: 0.5em;">
        <ion-datetime *ngIf="_value" id="{{id}}" (ionCancel)="datetimeIonCancel($event)" (ionChange)="datetimeIonChange($event)" [value]="_value" 
            [showDefaultButtons]="false"
            first-day-of-week="1"  class="embed" presentation="date"
            max="{{ max }}" min="{{ min }}" [preferWheel]="true" #datetime style="display: inline-block; visibility: hidden; height: 100px;"></ion-datetime>
      </td>
      <td style="padding: 0.5em;">
        <ion-datetime *ngIf="presentation == 'date-time' && _value" id="{{id}}" (ionCancel)="datetimeIonCancel($event)" (ionChange)="datetimeIonChange($event)" [value]="_value" 
            [showDefaultButtons]="false" minuteValues="0,15,30,45"
            first-day-of-week="1"  class="embed" presentation="time"
            max="{{ max }}" min="{{ min }}" [preferWheel]="true" #datetime style="display: inline-block; visibility: hidden; height: 100px;"></ion-datetime>
      </td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="!isEmbed">
  <ion-input type="text" (click)="buttonClickCB()" (focus)="buttonClickCB()" [readonly]="true" [value]="buttonLabel" [style]="maxHeight ? 'max-height:' + maxHeight +';':''"></ion-input>

  <ion-modal class="modalDateTimeButton" style="--backdrop-opacity: 0.5;" [keepContentsMounted]="true" (ionModalDidDismiss)="hideCalendarCB()" (ionModalWillPresent)="showWillCalendarCB()" (ionModalDidPresent)="showCalendarCB()" #modal>
    <ng-template>
      <ion-header *ngIf="title != null">
        <ion-toolbar>
          <ion-title>{{ title }}</ion-title>
        </ion-toolbar>
      </ion-header>
      
      <ion-content class="no-scroll" scroll-y="false" style="--overflow: hidden;overflow: hidden;">
        <ion-grid>
          <ion-row><ion-col class="modalDateTimeButtonCol1">
            <ion-datetime *ngIf="_value" id="{{id}}" (ionCancel)="datetimeIonCancel($event)" (ionChange)="datetimeIonChange($event)" [value]="_value" 
                [showDefaultButtons]="true"  doneText="{{ 'Ok' | translate}}" cancelText="{{ 'Cancel' | translate}}" 
                first-day-of-week="1" [presentation]="presentation == 'week' ? 'date': presentation" class=""
                max="{{ max }}" min="{{ min }}" #datetime></ion-datetime>
          </ion-col>
          <ion-col class="modalDateTimeButtonCol2">
            <div style="max-height: 350px; display: block; overflow-y: auto; overflow-x: hidden;" id="{{id}}__items">
              <ion-button size="small" (click)="selectBtYearCB(y)" [fill]="year != y ? 'clear': 'solid'" *ngFor="let y of years" style="display: block;" id="{{id}}__item__{{y}}">
                {{y}}
              </ion-button>
            </div>
          </ion-col></ion-row>
        </ion-grid>
      </ion-content>
    </ng-template>
  </ion-modal>
</ng-container>